import React from 'react';
import ActiveAlarmList from './ActiveAlarmList';
import useHelp from '../../utils/hooks/useHelp';

const AlarmListTabs = () => {
  useHelp('alarmlist');

  return (
    <>
      <ActiveAlarmList />
    </>
  );
};

export default AlarmListTabs;
